import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DeviceResponse } from '@/types/apps/device.type';
import type { GqlListResponse } from '@/types/common/api.type';

import { BaseService } from '@/types/service/graphql-service.type';

export interface DeviceServiceGraphQLInterface {}

type DeviceListResponse = GqlListResponse<DeviceResponse>;

export class DeviceGraphQLService
    extends BaseService
    implements DeviceServiceGraphQLInterface
{
    public getEntityName(): string {
        return 'device';
    }

    public getFields(): Record<string, any> {
        return {
            address: true,
            name: true,
            note: true,
            customerId: true,
            customer: {
                code: true,
                name: true,
            },
            id: true,
            installationDate: true,
            serialNumber: true,
            deviceSKU: {
                name: true,
            },
            rfid: true,
            contractCode: true,
            assigneeId: true,
            assignee: {
                id: true,
                fullname: true,
            },
        };
    }

    public async index(query: string): Promise<DeviceListResponse> {
        return this.fetchGqlList<DeviceListResponse>(
            query,
            this.getEntityName()
        ).then(res => {
            return {
                ...res,
                items: res.items.map(item => ({
                    ...item,
                    customName: `${item.serialNumber} - ${item.name}`,
                })),
            };
        });
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('device', {
            userId: this.getQueryById(),
        });
    }
}
